import type { CarrierLogoProps } from './types'
import LogoSvg from '../../assets/carrier-logos/axlehire-logo.svg?react'
import { chakra } from '../../chakra'
import { getLogoProps } from './use-logo-props'
import * as React from 'react'

const Logo = chakra(LogoSvg)

export const AXLEHIRELogo = React.forwardRef<SVGSVGElement, CarrierLogoProps>(
  function AXLEHIRELogo(props, ref) {
    const logoProps = getLogoProps(props, {
      primary: { light: '#2e2c6b', dark: '#5E5D9F' },
    })

    return <Logo {...logoProps} ref={ref} />
  },
)
